import React, { Component } from 'react';
import { Container, Form, Row} from 'react-bootstrap';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../../Config/Theme';

const Div = styled.div`
    background-color: white;
    color: black;
`

class Development extends Component{

    render() {
        return (
            <ThemeProvider theme={theme}>
                <Div>
                    <Container>
                        <Form className="p-3">
                            
                            <div className="form-section">
                                <h4>Employee Development</h4>
                                <hr />
                                <p className="font-italic font-weight-bold">
                                On a scale from 1 to 5 (1-Very Unsatisfied and
                                5-Very Satisfied...)
                                </p>

                                <Form.Group
                                as={Row}
                                name="formDevelopment"
                                controlId="formDevelopment"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    19. How satisfied are you with the professional growth and development opportunities provided?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formDevelopment"
                                    id="formDevelopment-1"
                                    defaultChecked={this.props.formDevelopment === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formDevelopment"
                                    id="formDevelopment-2"
                                    defaultChecked={this.props.formDevelopment === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formDevelopment"
                                    id="formDevelopment-3"
                                    defaultChecked={this.props.formDevelopment === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formDevelopment"
                                    id="formDevelopment-4"
                                    defaultChecked={this.props.formDevelopment === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formDevelopment"
                                    id="formDevelopment-5"
                                    defaultChecked={this.props.formDevelopment === 5}
                                />
                                </Form.Group>

                                
                                
                            </div>
                        </Form>
                    </Container>
                </Div>
            </ThemeProvider>
        )
    }
}

export default Development;